export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 1000000;
export const RES_PER_PAGE = 10;
export const KEY = 'f22dc475-4f8b-4809-88fe-e217530f574e';
export const MODAL_CLOSE_SEC = 2.5;